import { render, staticRenderFns } from "./modal-terminos.vue?vue&type=template&id=4882a18c&lang=html&"
import script from "./modal-terminos.vue?vue&type=script&lang=js&"
export * from "./modal-terminos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports